import { Event } from "../../models/events";

export const orderEventsPerDate = (data: Event[] | undefined): Event[] => {
    if (!data) return [];
    const sortedEvents = [...data].sort((a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime());
    
    return sortedEvents;
};